import {useField, useForm} from "vee-validate";
import * as yup from 'yup'

export function useUserForm(fn, fio, mobile, docs, mail, userId, equip, date, location, home) {
    const {isSubmitting, handleSubmit} = useForm({
        initialValues: {
            id: userId,
            name: fio,
            phone: mobile,
            contract: docs,
            email: mail,
            equipment: equip,
            address: home,
            validity: date,
            trest: location
        }
    })

    const {value: id, errorMessage: idError, handleBlur: idBlur} = useField('id',
        yup.string()
            .trim()
            .required('Введите Id')
    )
    const {value: name, errorMessage: nError, handleBlur: nBlur} = useField('name',
        yup.string()
            .trim()
            .required('Введите ФИО')
    )
    const {value: phone, errorMessage: pError, handleBlur: pBlur} = useField('phone',
        yup.string()
            .required('Введите телефон')
            .trim()
            .length(11, 'Номер состоит из 11 цифр')
    )
    const {value: contract, errorMessage: cError, handleBlur: cBlur} = useField('contract',
        yup.string()
            .required('Введите номер договора')
            .trim()
            .length(6, 'Номер состоит из 6 символов')
    )
    const {value: email, errorMessage: eError, handleBlur: eBlur} = useField(
        'email',
        yup
            .string()
            .trim()
            .email()
            .max(30, 'слишком длинный email')
    )
    const {value: address, errorMessage: aError, handleBlur: aBlur} = useField('address',
        yup.string()
            .required('Введите адрес')
    )
    const {value: equipment, errorMessage: eqError, handleBlur: eqBlur} = useField('equipment',
        yup.string()
            .required('Введите оборудование')
    )
    const {value: validity, errorMessage: vError, handleBlur: vBlur} = useField('validity',
        yup.date()
            .required('Введите срок действия договора')
    )

    const {value: trest} = useField('trest')
    const userSubmit = handleSubmit(fn)

    return {
        isSubmitting,
        userSubmit,
        id,
        name,
        phone,
        contract,
        email,
        address,
        equipment,
        validity,
        trest,
        idError,
        idBlur,
        nError,
        nBlur,
        pError,
        pBlur,
        cError,
        cBlur,
        eError,
        eBlur,
        aError,
        aBlur,
        eqError,
        eqBlur,
        vError,
        vBlur

    }
}